var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[(_vm.$slots.header)?_c('div',{class:_vm.$style.header},[_vm._t("header")],2):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("content")],2),_c('div',{class:_vm.$style.footer},[_vm._t("footer",function(){return [_c('div',{class:_vm.$style.logo},[_c('img',{attrs:{"src":_vm.getLogoLink,"alt":""}})])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }